<template>
    <div class="modal-content move-to-clients-popup">
        <div class="modal-header">
        <h5 class="modal-title">Перемещение в юр. лица</h5>
        <button type="button" class="close" aria-label="Close" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
        </button>
        </div>
        <div class="modal-body">
            <div class="move-to-clients-popup__body form-group row align-items-top">
              <label for="companyName" class="col-4 form-control-label">{{ $t('home.client') }}:</label>
              <div class="col-8">
                  <autocomplete id="companyName" :suggestions="companyNames" :selectionText.sync="companyName" :selectionId.sync="companyId"></autocomplete>
              </div>
            </div>
        </div>
        <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="$emit('close')">Закрыть</button>
        <button type="button" class="btn btn-primary" @click="apply" :disabled="!companyId">Переместить</button>
        </div>
    </div>
</template>

<script>
import api from '../../../api'
import autocomplete from '../../../components/autocoplete.vue'

const mapCompany = company => {
  return {
    id: company.id,
    name: company.name,
    address: company.address,
    email: company.email,
    phone: company.telephone,
    description: company.description
  }
}

export default {
  name: 'CancelTransactionPopup',
  props: {
    moveToCompanyAction: {
      type: Function,
      required: true
    }
  },
  components: {
    autocomplete
  },
  data () {
    return {
      companies: [],
      companyId: null,
      companyName: ''
    }
  },
  computed: {
    companyNames () {
      return this.companies.map(x => { return { value: x.id, text: x.name, search: `${x.name}${x.email}${x.phone}`.replace(/[^a-zA-Zа-яА-Я0-9]+/g, '').toLowerCase() } })
    }
  },
  created () {
    this.loadCompanies()
  },
  methods: {
    loadCompanies () {
      api.get
        .companies()
        .then(resp => {
          this.companies = resp.data.data.legalEntities
            .map(mapCompany)
            .sort(function (a, b) {
              if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1
              }
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1
              }
              return 0
            })
        })
        .catch(() => this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        }))
    },
    apply () {
      this.moveToCompanyAction(this.companyId)
      this.$emit('close')
    }
  },
  watch: {
    companyId: function (val) {
      const companyInfo = this.companies.find(x => x.id === val)
      if (companyInfo) {
        this.companyId = companyInfo.id
      } else {
        this.companyId = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .move-to-clients-popup__body {
    min-height: 100px;
  }
</style>
